<template>
    <div>
        <div class="columns" style="margin-bottom: 0;">
            <div class="column">
                <b-skeleton width="auto" height="40"></b-skeleton>
            </div>
            <div class="column">
                <b-skeleton width="auto" height="40"></b-skeleton>
            </div>
            <div class="column">
                <b-skeleton width="auto" height="40"></b-skeleton>
            </div>
        </div>
        <b-skeleton width="auto" height="35"></b-skeleton>
        <b-skeleton width="auto" height="35"></b-skeleton>
        <b-skeleton width="auto" height="35"></b-skeleton>
        <div class="is-pulled-right" style="margin-top: 10px;">
            <div class="columns">
                <div class="column" style="padding-right: 0;">
                    <b-skeleton width="35" height="35"></b-skeleton>
                </div>
                <div class="column" style="padding-right: 0;">
                    <b-skeleton width="35" height="35"></b-skeleton>
                </div>
                <div class="column">
                    <b-skeleton width="35" height="35"></b-skeleton>
                </div>
            </div>
        </div>
        <div class="is-clearfix"></div>
    </div>
</template>

<script>
    export default {
        name: "TableSkeleton",
        props: {
            hasImage: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style scoped>

</style>